import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../reducers';
import { QueryParamsModel, QueryResultsModel } from '../../_base/crud';
import { environment } from '../../../../environments/environment';
import { currentUser } from '../../auth';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DeviceInventoryService {
  private companyId: any;
  private baseUrl = `${environment.ME_BASE}/`;

  constructor(private httpClient: HttpClient, private store: Store<AppState>) {
    this.store.pipe(select(currentUser)).subscribe((res) => (this.companyId = res.companyID));
  }

  private static getInventoriesListQueryString(queryParams: QueryParamsModel): string {
    const { pageNumber, pageSize, sortField, sortOrder, filter } = queryParams;
    let fromString = `page=${pageNumber}&size=${pageSize}&sort=${sortField},${sortOrder}`;

    if (filter.searchTerm) {
      fromString += `&term=${filter.searchTerm}`;
    } else {
      if (filter.serial_id) fromString += `&serialId=${filter.serial_id}`;
      if (filter.date_assigned) fromString += `&dateAssigned=${filter.date_assigned}`;
      if (filter.date_procured) fromString += `&dateProcured=${filter.date_procured}`;
      if (filter.date_last_sync) fromString += `&dateLastSync=${filter.date_last_sync}`;
      if (filter.last_battery_value) fromString += `&lastBatteryValue=${filter.last_battery_value}`;
      if (filter.last_signal_strength)
        fromString += `&lastSignalStrength=${filter.last_signal_strength}`;
      if (filter.device_name) fromString += `&device_ids=${filter.device_name}`;
      if (filter.patient_id) fromString += `&patientName=${filter.patient_id}`;
    }

    return fromString;
  }

  loadDeviceInventories(queryParams: QueryParamsModel): Observable<any> {
    const params = new HttpParams({
      fromString: DeviceInventoryService.getInventoriesListQueryString(queryParams),
    });

    return this.httpClient.get<QueryResultsModel>(
      `${this.baseUrl}companies/${this.companyId}/inventory`,
      { params },
    );
  }

  createDeviceInventory(device: any): Observable<any> {
    const url = `${this.baseUrl}companies/${this.companyId}/inventory`;
    return this.httpClient.post<any>(url, device);
  }

  deleteDeviceInventory(device: any) {
    return this.httpClient.delete<any>(
      `${this.baseUrl}companies/${this.companyId}/inventory/${device.id}`,
    );
  }

  // tslint:disable-next-line:variable-name
  getPatientRange(device_id: any, patient_id: any): Observable<any> {
    const url = `${this.baseUrl}companies/${this.companyId}/patient_ranges`;
    // tslint:disable-next-line:max-line-length
    const params = new HttpParams({
      fromString: 'device_id=' + device_id + '&patient_id=' + patient_id,
    });

    return this.httpClient.get<any>(url, { params });
  }

  getInventoryForm(formID: number): Observable<any> {
    const url = `${environment.EVENT_BASE}/forms/${formID}`;

    return this.httpClient.get<any>(url);
  }

  submitPatientRanges(patient_id: any, device_id: any, rangeModel: any) {
    const url = `${this.baseUrl}companies/${this.companyId}/patient_ranges`;
    const model = {
      patient_id: patient_id,
      device_id: device_id,
      range: JSON.stringify(rangeModel),
      start_date: new Date(),
    };
    return this.httpClient.post<any>(url, model);
  }

  updateDeviceInventory(payload: any, id: any) {
    const url = `${this.baseUrl}companies/${this.companyId}/inventory/${id}/v2`;
    return this.httpClient.put<any>(url, payload);
  }

  unassignedPatient(payload: any, id: any) {
    const url = `${this.baseUrl}companies/${this.companyId}/inventory/${id}/assign_unassigned?assign=UNASSIGNED`;
    return this.httpClient.put<any>(url, payload);
  }

  assignedPatient(payload: any, id: any) {
    const url = `${this.baseUrl}companies/${this.companyId}/inventory/${id}/assign_unassigned?assign=ASSIGN`;
    return this.httpClient.put<any>(url, payload);
  }

  searchInventories(device_ids: number, term: string): Observable<any> {
    const params = new HttpParams({
      fromString:
        `term=${term}` +
        `&device_ids=${device_ids}` +
        `&active=true&assigned=false&sort=serialId,asc`,
    });
    return this.httpClient.get<any>(`${this.baseUrl}companies/${this.companyId}/inventory`, {
      params,
    });
  }
}
